module.exports = __webpack_public_path__ + "img/abrapa.2faa73bb.png";